import React, { useState } from 'react';
import '../Styles/Insights.css';

const insightsData = [
  {
    name: 'Sanjay',
    designation: 'UX/UI Designer',
    company: 'Inypeople',
    date: 'Sep 23',
    message: `Boost Your Business with Workplace Culture Certification

Why It Matters:
• Enhance reputation and credibility.
• Attract top talent and reduce turnover.
• Improve employee engagement and productivity.
• Stand out in a competitive market.`,
    fullMessage: `Boost Your Business with Workplace Culture Certification

Why It Matters:
• Enhance reputation and credibility.
• Attract top talent and reduce turnover.
• Improve employee engagement and productivity.
• Stand out in a competitive market.

Benefits of Certification:
• Increased employee satisfaction and retention.
• Improved collaboration and communication.
• Better decision-making and problem-solving.
• Enhanced brand reputation and customer loyalty.

Driving Business Growth:
• Increased productivity and efficiency.
• Improved employee morale and motivation.
• Access to best practices and industry insights.
• Competitive edge in the market.

Achieving Certification:
• Assess your current culture.
• Develop a strategic plan.
• Implement changes and improvements.
• Evaluate and maintain certification.

Partner with us to achieve Certified Workplaces status and unlock the benefits of a positive, productive work environment!`,
    mediaType: 'image',
    mediaSrc: '/insights1.jpg',
    avatar: '/profile.png',
    linkedin: 'https://www.linkedin.com/in/sanjay-profile'
  },
  {
    name: 'Priya',
    designation: 'HR Manager',
    company: 'TechNova',
    date: 'Oct 25',
    message: `The Power of Empathy: Transforming Leadership and Business

Key Benefits of Empathetic Leadership:
• Increased Employee Engagement: Empathetic leaders foster a sense of ownership and pride in work, leading to higher performance and better outcomes.`,
    fullMessage: `The Power of Empathy: Transforming Leadership and Business

Key Benefits of Empathetic Leadership:
Increased Employee Engagement:
• Empathetic leaders foster a sense of ownership and pride in work, leading to higher performance and better outcomes.

Improved Decision-Making:
• Empathy allows leaders to consider diverse perspectives, making informed decisions that benefit the organization in the long run.

Innovation and Creativity:
• Empathetic leaders create an open and inclusive environment where employees feel safe to share ideas, leading to creative problem-solving and innovation.

Better Employee Well-being:
• Empathetic leaders prioritize employee mental health, reducing burnout and promoting a healthier work environment.

Stronger Organizational Culture:
• Empathy promotes collaboration, open communication, and mutual respect, shaping a positive and productive work culture.

Characteristics of Empathetic Leaders:
Active Listening:
• Giving full attention to employees and responding with genuine interest.

Emotional Intelligence:
• Recognizing and understanding emotions in themselves and others.

Openness and Approachability:
• Creating a safe space for employees to express concerns and ideas.

Empathetic Decision-Making:
• Considering the human impact of decisions alongside financial and strategic considerations.

Why Empathy Matters:
Empathy is not just a "soft skill" but a strategic asset that drives business success. It's about understanding and valuing the human side of work, recognizing that employees are not just workers but individuals with unique needs, motivations, and challenges.`,
    mediaType: 'image',
    mediaSrc: '/insights2.png',
    avatar: '/profile2.png',
    linkedin: 'https://www.linkedin.com/in/priya-profile'
  },
  {
    name: 'Amit',
    designation: 'CEO',
    company: 'BizGrowth',
    date: 'Nov 25',
    message: `Transforming Company Culture with Certified and Actionable Insights

At our organization, we believe that a strong company culture is the backbone of any successful business. It's what drives employee engagement, innovation, and ultimately, business growth.`,
    fullMessage: `Transforming Company Culture with Certified and Actionable Insights

At our organization, we believe that a strong company culture is the backbone of any successful business. It's what drives employee engagement, innovation, and ultimately, business growth. Our mission is to help companies like yours transform their culture and unlock their full potential.

We use a comprehensive approach to culture transformation, focusing on:

Defining Core Value:
• Establishing a clear set of values that reflect your company's mission and vision.

Assessing Current Culture:
• Conducting thorough assessments to identify areas for improvement and opportunities for growth.

Building a Culture Framework:
• Developing a tailored framework that aligns with your company's goals and objectives.

Certified and Actionable Insights.
Our team of experts provides certified and actionable insights to help you:

Improve Employee Engagement:
• Boost morale, motivation, and productivity through targeted recognition and reward programs.

Foster Innovation:
• Encourage creativity, experimentation, and learning through inclusive practices and feedback mechanisms.

Develop Leadership:
• Equip leaders with the skills and knowledge to drive cultural transformation and sustain business growth.

Partner with Us
By partnering with us, you'll gain access to:

Expert Guidance:
• Proven methodologies and best practices to drive cultural transformation.

Actionable Insights:
• Data-driven insights to inform strategic decisions and drive business outcomes.

Sustainable Results:
• Long-term cultural transformation that drives business success.

Let's work together to transform your company culture and unlock your full potential.`,
    mediaType: 'image',
    mediaSrc: '/insights3.jpg',
    avatar: '/profile3.png',
    linkedin: 'https://www.linkedin.com/in/amit-profile'
  }
  // ...add more insights as needed
];

// Helper to format all subheadings in bold and bullets
function formatSubAndBullets(msg) {
  const lines = msg.split('\n').filter(Boolean);
  let jsx = [];
  let i = 1; // Skip heading (first line)
  for (; i < lines.length; i++) {
    // Subheading: ends with ':' and not a bullet
    if (!lines[i].startsWith('•') && lines[i].trim().endsWith(':')) {
      jsx.push(
        <div key={`subheading-${i}`} style={{ fontWeight: 'bold', marginTop: 16, marginBottom: 6 }}>
          {lines[i]}
        </div>
      );
    } else if (lines[i].startsWith('•')) {
      jsx.push(
        <div key={`bullet-${i}`} style={{ marginLeft: 12, marginBottom: 2 }}>
          {lines[i]}
        </div>
      );
    } else {
      jsx.push(
        <div key={`text-${i}`} style={{ marginBottom: 6 }}>
          {lines[i]}
        </div>
      );
    }
  }
  return jsx;
}

// Helper to get heading only
function getHeading(msg) {
  const lines = msg.split('\n').filter(Boolean);
  return lines[0] || '';
}

function Insights() {
  const [overlayOpen, setOverlayOpen] = useState(false);
  const [activeInsight, setActiveInsight] = useState(null);
  const [visibleCount, setVisibleCount] = useState(6);

  const handleReadMore = (idx) => {
    setActiveInsight(idx);
    setOverlayOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const handleCloseOverlay = () => {
    setOverlayOpen(false);
    setActiveInsight(null);
    document.body.style.overflow = '';
  };

  const handleLoadMore = () => {
    setVisibleCount((prev) => prev + 6);
  };

  // Card message formatter (heading, subheading, bullets)
function formatMessage(msg, idx) {
  const lines = msg.split('\n').filter(Boolean);
  let jsx = [];
  let i = 0;
  // Heading
  if (lines[i]) {
    jsx.push(
      <div key={`heading-${i}`} style={{ fontWeight: 'bold', fontSize: '1.08rem', marginBottom: 6 }}>
        {lines[i]}
      </div>
    );
    i++;
  }
  // For the 3rd card (idx === 2), do NOT bold the second line
  if (lines[i] && !lines[i].startsWith('•')) {
    jsx.push(
      <div
        key={`subheading-${i}`}
        style={{
          fontWeight: idx === 2 ? 'normal' : 'bold',
          marginBottom: 6
        }}
      >
        {lines[i]}
      </div>
    );
    i++;
  }
  // Bullets and other lines
  for (; i < lines.length; i++) {
    if (lines[i].startsWith('•')) {
      jsx.push(
        <div key={`bullet-${i}`} style={{ marginLeft: 12, marginBottom: 2 }}>
          {lines[i]}
        </div>
      );
    } else {
      jsx.push(
        <div key={`text-${i}`} style={{ marginBottom: 6 }}>
          {lines[i]}
        </div>
      );
    }
  }
  return jsx;
}

  return (
    <div className="insights-container">
      <h2 className="insights-title">Latest Insights</h2>
      <div className="insights-list">
        {insightsData.slice(0, visibleCount).map((item, idx) => (
          <div className="insight-card" key={idx}>
            <div className="insight-card-media">
              {item.mediaType === 'video' ? (
                <video controls>
                  <source src={item.mediaSrc} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              ) : (
                <img src={item.mediaSrc} alt="Insight Media" />
              )}
            </div>
            {/* 
            // Temporarily hidden meta info:
            <div className="insight-card-meta">
              <img className="insight-avatar" src={item.avatar} alt={item.name} />
              <div className="insight-meta-details">
                <div className="insight-meta-line1">
                  <span className="insight-author">{item.name}</span>
                  <span className="insight-designation">{item.designation}</span>
                </div>
                <div className="insight-meta-line2">
                  <span className="insight-company">{item.company}</span>
                  <span className="insight-date">{item.date}</span>
                </div>
              </div>
              <div className="insight-linkedin">
                <a href={item.linkedin} target="_blank" rel="noopener noreferrer">
                  <img src="/linkedin-icon.png" alt="LinkedIn" />
                </a>
              </div>
            </div>
            */}
            <div className="insight-card-message">
              {formatMessage(item.message, idx)}
              {item.fullMessage && (
                <span className="read-more" onClick={() => handleReadMore(idx)}> Read more</span>
              )}
            </div>
          </div>
        ))}
      </div>
      {visibleCount < insightsData.length && (
        <div className="insights-loadmore-wrap">
          <button className="insights-loadmore-btn" onClick={handleLoadMore}>
            Load More
          </button>
        </div>
      )}
      {overlayOpen && activeInsight !== null && (
        <div className="insight-overlay">
          <div className="insight-overlay-content large">
            <button className="overlay-close" onClick={handleCloseOverlay}>×</button>
            <div className="overlay-scroll-area">
              {/* Heading first */}
              <div className="insight-overlay-heading" style={{ fontWeight: 'bold', fontSize: '1.18rem', marginBottom: 10 }}>
                {getHeading(insightsData[activeInsight].fullMessage)}
              </div>
              {/* Image after heading */}
              <div className="insight-card-media" style={{ marginBottom: 18 }}>
                {insightsData[activeInsight].mediaType === 'video' ? (
                  <video controls>
                    <source src={insightsData[activeInsight].mediaSrc} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                ) : (
                  <img src={insightsData[activeInsight].mediaSrc} alt="Insight Media" />
                )}
              </div>
              {/* 
              // Temporarily hidden meta info:
              <div className="insight-card-meta">
                <img className="insight-avatar" src={insightsData[activeInsight].avatar} alt={insightsData[activeInsight].name} />
                <div className="insight-meta-details">
                  <div className="insight-meta-line1">
                    <span className="insight-author">{insightsData[activeInsight].name}</span>
                    <span className="insight-designation">{insightsData[activeInsight].designation}</span>
                  </div>
                  <div className="insight-meta-line2">
                    <span className="insight-company">{insightsData[activeInsight].company}</span>
                    <span className="insight-date">{insightsData[activeInsight].date}</span>
                  </div>
                </div>
                <div className="insight-linkedin">
                  <a href={insightsData[activeInsight].linkedin} target="_blank" rel="noopener noreferrer">
                    <img sarc="/linkedin-icon.png" alt="LinkedIn" />
                  </a>
                </div>
              </div>
              */}
              {/* All subheadings bold and bullets */}
              <div className="insight-card-message">
                {formatSubAndBullets(insightsData[activeInsight].fullMessage)}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Insights;